import {View} from 'MWC';
import tpl from './templates/interactive';
import {apiback} from '../../../config';
import {Sync} from 'MWComponents';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            offerMembers: '-',
            transactionCount: '-'
        };
        return this;
    }

    componentWillReady = async resolve => {
        await this.getStat();
        resolve();
    };

    async getStat() {
        const Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: {
                    conv_data: {
                        step: 'participant'
                    },
                    hash: 'D531DFS13FDFG322' // хеш определяет в какой конвеер будет отправлен запрос
                },
                cache: false
            });
        try {
            const response = await xhr.post();
            if (response.data.data.status !== 'ok') {
                throw new Error();
            } else {
                this.setState({
                    offerMembers: response.data.data.cnt_clid,
                    transactionCount: response.data.data.cnt_tranz
                });
            }
        } catch (error) {
            return error;
        }
    }

    static displayName = 'McGiftsModule';
}
